import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FormGroup, FormLabel, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FormUtils from "../../utils/FormUtils";
import { GoogleSignIn, MicrosoftSignIn } from "./SSO";
import OrDivider from "../Shared/OrDivider";

const LoginForm = () => {
  const [isLoading, shouldLoad] = useState(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  return (
    <>
      <FormGroup>
        <GoogleSignIn />
      </FormGroup>

      <FormGroup>
        <MicrosoftSignIn />
      </FormGroup>

      <FormGroup sx={{ margin: "1rem" }}>
        <OrDivider />
      </FormGroup>

      <form
        method="post"
        action="/verifications"
        onSubmit={(e) => {
          FormUtils.onFormSubmit(e);
          shouldLoad(true);
        }}
      >
        <FormGroup>
          <FormLabel>
            We suggest using the <strong>email address you use at work</strong>.
          </FormLabel>
        </FormGroup>

        <FormGroup>
          <TextField
            name="email"
            type="email"
            required
            label="Email"
            variant="filled"
          />
        </FormGroup>

        <FormGroup>
          <input
            type="hidden"
            name="redirect_url"
            value={queryParams.get("redirect_url") ?? ""}
          />
          <LoadingButton
            variant="outlined"
            color="primary"
            type="submit"
            loading={isLoading}
          >
            Verify
          </LoadingButton>
        </FormGroup>
      </form>
    </>
  );
};

export default LoginForm;
